import React from "react";
import ComplexText from "@ui/complex-text";
import WidgetContainer from "@widgets/render-engine/widget-container";
import PickWidget from "@widgets/render-engine/pick-widget";
import Card from "@ui/card";
import { useMediumScreen } from "@helpers/use-media-query";

const CoreCompositeWidget = ({ items, widthPercents }) => {
    if (!items) return null;
    return (
        <>
            {items.map((item, index) => {
                const style = widthPercents
                    ? {
                          width:
                              widthPercents.length > index
                                  ? `${widthPercents[index]}%`
                                  : "",
                      }
                    : {};
                return (
                    <div key={index} style={style}>
                        <WidgetContainer data={item.data}>
                            <PickWidget widget={item} />
                        </WidgetContainer>
                    </div>
                );
            })}
        </>
    );
};

const CompositeWidget = ({ data }) => {
    const mediumScreen = useMediumScreen();
    if (!data.items) return null;

    const isHorizontalForLargeScreen =
        data.orientationForLargeScreen &&
        data.orientationForLargeScreen === "Horizontal";

    const isHorizontal = data.orientation && data.orientation === "Horizontal";

    const orientationForLargeScreenCss = isHorizontalForLargeScreen
        ? "md:flex"
        : "";

    const orientationCss = isHorizontal === "Horizontal" ? "flex" : "";

    const hasGap = data.horizontalGap && data.horizontalGap > 0;

    const gap =
        hasGap && isHorizontalForLargeScreen && mediumScreen
            ? data.horizontalGap
            : hasGap && isHorizontal && !mediumScreen
            ? data.horizontalGap
            : 0;

    const reverseCss =
        mediumScreen && isHorizontalForLargeScreen ? "md:flex-row-reverse" : "";

    const style = {
        gap: gap > 0 ? `${gap}px` : "",
    };

    const widthPercents =
        mediumScreen && (isHorizontal || isHorizontalForLargeScreen)
            ? data.horizontalWidthPercentPerItems ?? []
            : [];

    const wrapLayoutCss = data.wrapLayoutInContentArea
        ? "max-w-5xl mx-auto px-4"
        : "";

    if (data.layoutMode === "Card") {
        return (
            <div className={`${wrapLayoutCss}`}>
                {data.heading && (
                    <h2 className="text-lg font-semibold mb-5 text-skin-dark md:text-xl">
                        <ComplexText values={data.heading} />
                    </h2>
                )}
                <CoreCompositeWidget items={data.headers} />
                <Card
                    className={`border ${orientationCss} ${orientationForLargeScreenCss} ${reverseCss}`}
                    style={style}
                >
                    <CoreCompositeWidget
                        items={data.items}
                        widthPercents={widthPercents}
                    />
                </Card>
                <CoreCompositeWidget items={data.footers} />
            </div>
        );
    }

    const bgColour =
        data.backgroundColour && data.backgroundColour == "PrimaryLight"
            ? "rgba(242,250,255,1)"
            : "";

    const wrapStyle = {
        paddingTop: data.paddingTop ? `${data.paddingTop}px` : null,
        paddingBottom: data.paddingBottom ? `${data.paddingBottom}px` : null,
        background:
            data.backgroundColour && data.backgroundColourPercent
                ? "rgb(255,255,255)"
                : bgColour,
        backgroundImage:
            data.backgroundColour && data.backgroundColourPercent
                ? `linear-gradient(0deg, rgba(255,255,255,1) ${data.backgroundColourPercent}%, ${bgColour} ${data.backgroundColourPercent}%)`
                : null,
    };

    return (
        <div style={wrapStyle}>
            <div className={`${wrapLayoutCss}`}>
                <CoreCompositeWidget items={data.headers} />
                <div
                    className={`${orientationCss} ${orientationForLargeScreenCss} ${reverseCss}`}
                    style={style}
                >
                    <CoreCompositeWidget
                        items={data.items}
                        widthPercents={widthPercents}
                    />
                </div>
                <CoreCompositeWidget items={data.footers} />
            </div>
        </div>
    );
};

export default CompositeWidget;
